import { gql } from '@apollo/client'

export const MARK_NOTIFICATION_AS_READ = gql`
  mutation markNotificationAsRead($notificationId: Int!) {
    markNotificationAsRead(notificationId: $notificationId) {
      success
      errors {
        field
        message
      }
      notification {
        id
        isRead
        readAt
      }
    }
  }
`

export const MARK_NOTIFICATION_AS_UNREAD = gql`
  mutation markNotificationAsUnread($notificationId: Int!) {
    markNotificationAsUnread(notificationId: $notificationId) {
      success
      errors {
        field
        message
      }
      notification {
        id
        isRead
        readAt
      }
    }
  }
`

export const MARK_ALL_NOTIFICATIONS_AS_READ = gql`
  mutation markAllNotificationsAsRead {
    markAllNotificationsAsRead {
      success
      count
      errors {
        field
        message
      }
    }
  }
`

export const DELETE_NOTIFICATION = gql`
  mutation deleteNotification($notificationId: Int!) {
    deleteNotification(notificationId: $notificationId) {
      success
      errors {
        field
        message
      }
    }
  }
`
